module.exports = __webpack_public_path__ + "img/cloud_backup_down_arrow_b.aba21bf1.svg";